import { camelizeKeys } from "humps";
import { INVENTORY } from "app_constants";
import {
  checkStatus,
  getRequest,
  parseJSON,
  postRequest,
} from "helpers/requests";

export interface ICreateUserAttributes {
  avoidEmailNotification: boolean;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export interface IUser {
  email: string;
  id: string;
  firstName: string;
  lastName: string;
  phone: string;
}

function postCreateUser(
  user: ICreateUserAttributes,
  settingsToken: string
): Promise<IUser> {
  const params = {
    ...user,
    act: "create_user",
    requestToken: settingsToken,
    json: true,
  };

  return fetch(`${INVENTORY}/settings?act=create_user`, postRequest(params))
    .then(checkStatus)
    .then(parseJSON)
    .then((created) => camelizeKeys(created) as IUser);
}

interface IInventoryUserRoles {
  items: string[];
}

function postUserRoles(
  userId: string,
  roles: string[],
  token: string
): Promise<IInventoryUserRoles> {
  const updatedRoles: IInventoryUserRoles = { items: roles };
  const authHeader = { authorization: `Bearer ${token}` };
  return fetch(
    `${INVENTORY}/v2/users/${userId}/roles`,
    postRequest(updatedRoles, authHeader)
  )
    .then(checkStatus)
    .then(parseJSON)
    .then((updated) => camelizeKeys(updated.data) as IInventoryUserRoles);
}

function getUserRoles(
  userId: string,
  token: string
): Promise<IInventoryUserRoles> {
  const authHeader = { authorization: `Bearer ${token}` };
  return fetch(`${INVENTORY}/v2/users/${userId}/roles`, getRequest(authHeader))
    .then(checkStatus)
    .then(parseJSON)
    .then((created) => camelizeKeys(created.data) as IInventoryUserRoles);
}

export const Inventory = { postCreateUser, postUserRoles, getUserRoles };
